const RouteTeamComponent = () => import('@/views/RouteTeam/RouteTeamView')

export default [
    {
        path:'/RouetTeamIndex',
        name:'RouteTeamRouter',
        component:RouteTeamComponent
    }
]